// Import local dependencies
import './autoload/ada-compliance';
import './autoload/foundation';
import './plugins/lazyload';
import './plugins/swiper';

// Import external dependencies
import '@fancyapps/fancybox/dist/jquery.fancybox.min';
import AOS from 'aos';

/**
 * Init foundation
 */
$(document).foundation();

let headerHeightRAF = null;
let lastHeaderHeight = null;
// updated function (to solve the Forced reflow problem)
const setHeaderHeightVar = () => {
  if (headerHeightRAF) return;

  headerHeightRAF = requestAnimationFrame(() => {
    headerHeightRAF = null;

    const header = document.querySelector('header.header');
    if (!header) return;

    // layout read (1 time)
    const height = header.getBoundingClientRect().height;

    // don't write CSS if the value hasn't changed
    if (height === lastHeaderHeight) return;
    lastHeaderHeight = height;

    // style write (separate from read)
    document.documentElement.style.setProperty(
      '--header-height',
      `${height}px`
    );
  });
};

function debounce(fn, ms) {
  let timer;
  return function () {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, arguments), ms);
  };
}

const calendarSliderControls = () => {
  const prevArrow = document.querySelector('.calendar-slider__arrow--prev');
  const nextArrow = document.querySelector('.calendar-slider__arrow--next');
  const tabsHeader = $('[data-tabs].calendar-slider__header'); // jQuery
  const tabs = document.querySelectorAll('.calendar-slider__tab');

  if (!prevArrow || !nextArrow || !tabs.length || !tabsHeader.length) return;

  const getActiveTabIndex = () =>
    [...tabs].findIndex((tab) => tab.classList.contains('is-active'));

  const updateButtons = (index) => {
    prevArrow.classList.toggle('disabled', index === 0);
    nextArrow.classList.toggle('disabled', index === tabs.length - 1);
  };

  const goToTab = (index) => {
    if (index < 0 || index >= tabs.length) return;

    const tabLink = tabs[index].querySelector('a');
    if (!tabLink) return;

    const panelId = tabLink.getAttribute('href')?.slice(1);
    if (!panelId) return;

    tabsHeader.foundation('selectTab', panelId);
    updateButtons(index);
  };

  prevArrow.addEventListener('click', () => {
    if (prevArrow.classList.contains('disabled')) return;
    goToTab(getActiveTabIndex() - 1);
  });

  nextArrow.addEventListener('click', () => {
    if (nextArrow.classList.contains('disabled')) return;
    goToTab(getActiveTabIndex() + 1);
  });

  tabsHeader.on('change.zf.tabs', () => {
    updateButtons(getActiveTabIndex());
  });

  updateButtons(getActiveTabIndex());
};

const ourProcessSwitcher = () => {
  const wrappers = document.querySelectorAll('.our-process__list-wrapper');
  const initialBatch = [];

  wrappers.forEach((wrapper) => {
    const items = Array.from(
      wrapper.querySelectorAll('.our-process__list-item')
    );
    const backgrounds = Array.from(
      wrapper.querySelectorAll('.our-process__background')
    );
    const overlay = wrapper.querySelector('.our-process__list-item.overlay');

    if (!overlay || items.length === 0) return;

    function moveOverlayTo(item) {
      const {
        offsetWidth: width,
        offsetHeight: height,
        offsetLeft: left,
        offsetTop: top,
      } = item;

      overlay.style.cssText = `
        width: ${width}px;
        height: ${height}px;
        left: ${left}px;
        top: ${top}px;
      `;
    }

    const initialActive = wrapper.querySelector(
      '.our-process__list-item.active'
    );

    if (initialActive) {
      const metrics = {
        width: initialActive.offsetWidth,
        height: initialActive.offsetHeight,
        left: initialActive.offsetLeft,
        top: initialActive.offsetTop,
      };

      const initialIndex = items.indexOf(initialActive);
      const content = initialActive.querySelector(
        '.our-process__list-item-content'
      );

      initialBatch.push({
        overlay,
        metrics,
        backgrounds,
        initialIndex,
        content: content ? content.cloneNode(true) : null,
      });
    }

    // Event Listeners
    items.forEach((item, index) => {
      item.addEventListener('click', () => {
        if (item.classList.contains('active')) return;

        // Active class management
        items.forEach((i) => i.classList.remove('active'));
        item.classList.add('active');

        // Background switch
        backgrounds.forEach((bg) => bg.classList.remove('active'));
        if (backgrounds[index]) backgrounds[index].classList.add('active');

        // Move overlay
        requestAnimationFrame(() => {
          moveOverlayTo(item);
        });

        // Overlay content switch
        const content = item.querySelector('.our-process__list-item-content');
        if (content) {
          setTimeout(() => {
            overlay.classList.toggle('overlay--first', index === 0);
            overlay.replaceChildren(content.cloneNode(true));
          }, 400);
        }
      });
    });
  });

  // Writing Only
  if (initialBatch.length > 0) {
    requestAnimationFrame(() => {
      initialBatch.forEach(
        ({ overlay, metrics, backgrounds, initialIndex, content }) => {
          overlay.style.cssText = `
          width: ${metrics.width}px;
          height: ${metrics.height}px;
          left: ${metrics.left}px;
          top: ${metrics.top}px;
        `;

          if (backgrounds[initialIndex]) {
            backgrounds.forEach((bg) => bg.classList.remove('active'));
            backgrounds[initialIndex].classList.add('active');
          }

          if (content) {
            overlay.replaceChildren(content);
          }

          overlay.classList.toggle('overlay--first', initialIndex === 0);
        }
      );
    });
  }
};

const faqSearch = () => {
  const faqBlock = document.querySelector('.faq-block.with-search');

  if (!faqBlock) return;

  const searchInput = faqBlock.querySelector('.faq-block__search-field');
  const searchButton = faqBlock.querySelector('.faq-block__search-button');
  const faqItems = Array.from(
    faqBlock.querySelectorAll('.faq-block__list-item')
  );
  const errorMsg = faqBlock.querySelector('.faq-block__error-message');

  const normalize = (str) =>
    str
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();

  const setVisibility = (element, visible) => {
    element.style.display = visible ? '' : 'none';
  };

  // const showFirstFiveItems = (items) => {
  //   items.forEach((item, i) => setVisibility(item, i < 5));
  // };

  const performSearch = () => {
    const query = normalize(searchInput.value);
    const hasQuery = query.length > 0;

    const matchedItems = faqItems.filter((item) => {
      const titleEl = item.querySelector('.accordion-title');
      const contentEl = item.querySelector('.accordion-content__inner');
      const title = titleEl ? normalize(titleEl.textContent) : '';
      const content = contentEl ? normalize(contentEl.textContent) : '';
      const match =
        !hasQuery || title.includes(query) || content.includes(query);
      setVisibility(item, match);
      return match;
    });

    // showFirstFiveItems(matchedItems);

    if (errorMsg) {
      setVisibility(errorMsg, matchedItems.length === 0);
    }
  };

  // Show first five items on init
  // showFirstFiveItems(faqItems);

  searchButton.addEventListener('click', (e) => {
    e.preventDefault();
    performSearch();
  });

  searchInput.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      performSearch();
    }
  });

  let debounceTimeout;
  searchInput.addEventListener('input', () => {
    clearTimeout(debounceTimeout);
    debounceTimeout = setTimeout(performSearch, 300);
  });
};

const accordionAnimation = () => {
  document.querySelectorAll('.accordion-title').forEach((title) => {
    title.addEventListener('click', (e) => {
      e.preventDefault();

      const item = title.closest('.accordion-item');
      if (!item) return;

      const content = item.querySelector('.accordion-content');
      if (!content) return;

      const inner = content.querySelector('.accordion-content__inner');
      if (!inner) return;

      const isOpen = item.classList.contains('is-active');

      content.style.transition = 'height 800ms cubic-bezier(1, 0, 0.1, 1)';

      const onTransitionEnd = (event) => {
        if (event.target !== content || event.propertyName !== 'height') return;
        content.style.height = isOpen ? '0' : 'auto';
        if (isOpen) {
          content.style.display = 'none';
        }
        content.removeEventListener('transitionend', onTransitionEnd);
      };

      content.removeEventListener('transitionend', onTransitionEnd);
      content.addEventListener('transitionend', onTransitionEnd);

      if (isOpen) {
        content.style.height = content.scrollHeight + 'px';
        requestAnimationFrame(() => {
          content.style.height = '0';
        });
        item.classList.remove('is-active');
      } else {
        content.style.display = 'block';
        content.style.height = '0';
        requestAnimationFrame(() => {
          const h = inner.offsetHeight;
          content.style.height = h + 'px';
          item.classList.add('is-active');
        });
      }
    });
  });
};

const fwpDropdown = () => {
  const dropdowns = document.querySelectorAll('.fwp-dropdown');

  dropdowns.forEach((root) => {
    const btn = root.querySelector('.fwp-dropdown__button');
    const list = root.querySelector('.fwp-dropdown__list');
    const checks = Array.from(root.querySelectorAll('input[type="checkbox"]'));

    function open() {
      if (!list.hidden) return;
      list.hidden = false;
      root.classList.add('fwp-dropdown--open');
      btn.setAttribute('aria-expanded', 'true');
      document.addEventListener('click', onDocClick, { capture: true });
      document.addEventListener('keydown', onKeyDown);
    }

    function close() {
      if (list.hidden) return;
      list.hidden = true;
      root.classList.remove('fwp-dropdown--open');
      btn.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', onDocClick, { capture: true });
      document.removeEventListener('keydown', onKeyDown);
    }

    function toggle() {
      list.hidden ? open() : close();
    }

    function onDocClick(e) {
      if (!root.contains(e.target)) close();
    }

    function onKeyDown(e) {
      if (e.key === 'Escape') {
        close();
        btn.focus();
      }
    }

    function updateLabel() {
      const count = checks.filter((c) => c.checked).length;
      btn.childNodes[0].nodeValue = count
        ? `${btn.dataset.label} (${count}) `
        : `${btn.dataset.label} `;
    }

    function emitChange() {
      const selected = checks
        .filter((c) => c.checked)
        .map((c) => ({
          slug: c.value,
          termId: c.dataset.termId || null,
        }));
      root.dispatchEvent(
        new CustomEvent('dropdown:change', {
          detail: { selected, root },
          bubbles: true,
        })
      );
    }

    // Events
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      toggle();
    });

    btn.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggle();
      }
      if (e.key === 'ArrowDown' && list.hidden) {
        e.preventDefault();
        open();
      }
      if (e.key === 'ArrowUp' && !list.hidden) {
        e.preventDefault();
        close();
      }
    });

    checks.forEach((c) =>
      c.addEventListener('change', () => {
        updateLabel();
        emitChange();
      })
    );

    btn.dataset.label = btn.textContent.trim();

    updateLabel();
  });
};

const careResultsAjax = () => {
  var $root = $('.case-result-filtarable');

  if (!$root.length || !window.ajax_object) return;

  var $search = $root.find('.case-result-filtarable__filter-search-field');
  var $posts = $root.find('.case-result-filtarable__posts');
  var $count = $root.find('.case-result-filtarable__posts-result span');
  var $pagination = $root.find('.case-result-filtarable__pagination');
  var state = { page: 1, totalPages: 1 };

  function getCheckedIDs(blockMod) {
    return $root
      .find('.fwp-dropdown--' + blockMod + ' input[type="checkbox"]:checked')
      .map(function () {
        var id = $(this).attr('data-term-id');
        return id ? id : $(this).val();
      })
      .get();
  }

  function debounce(fn, ms) {
    var t;
    return function () {
      clearTimeout(t);
      var args = arguments,
        ctx = this;
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, ms || 300);
    };
  }

  function renderPagination(total, page) {
    $pagination.empty();
    if (total <= 1) return;

    function btn(label, target, current, extraClass) {
      return jQuery('<button>', {
        type: 'button',
        text: label,
        class:
          'pagination__btn' +
          (current ? ' is-current' : '') +
          (extraClass ? ' ' + extraClass : ''),
        'data-page': target,
      });
    }

    if (page > 1) {
      $pagination.append(btn('Prev', page - 1, false, 'is-prev'));
    }

    var win = 5;
    var start = Math.max(1, page - 2);
    var end = Math.min(total, start + win - 1);
    start = Math.max(1, Math.min(start, end - win + 1));

    for (var i = start; i <= end; i++) {
      $pagination.append(btn(String(i), i, i === page));
    }

    if (page < total) {
      $pagination.append(btn('Next', page + 1, false, 'is-next'));
    }
  }

  function request() {
    var data = {
      action: 'fwp_case_results',
      nonce: window.ajax_object.nonce,
      page: state.page,
      s: ($search.val() || '').trim(),
      practice: getCheckedIDs('practice'),
      quote: getCheckedIDs('quote'),
      locations: getCheckedIDs('location'),
    };

    $root.addClass('is-loading');
    $posts.attr('aria-busy', 'true');

    $.ajax({
      type: 'POST',
      url: window.ajax_object.ajax_url,
      data: data,
      dataType: 'json',
    })
      .done(function (resp) {
        if (!resp || !resp.success) {
          throw new Error('Invalid response');
        }
        var payload = resp.data || {};
        $posts.html(payload.html || '');
        $count.text(String(payload.total || 0));
        state.totalPages = payload.total_pages || 1;
        if (!payload.total) {
          $pagination.empty();
          return;
        }
        renderPagination(state.totalPages, state.page);
      })
      .fail(function (xhr) {
        console.error('AJAX failed', xhr?.responseText || xhr);
        $posts.html('<p>Something went wrong. Please try again.</p>');
        $count.text('0');
        $pagination.empty();
      })
      .always(function () {
        $root.removeClass('is-loading');
        $posts.removeAttr('aria-busy');
      });
  }

  function applyFilters(resetPage) {
    if (resetPage) state.page = 1;
    request();
  }

  $search.on(
    'input',
    debounce(function () {
      applyFilters(true);
    }, 300)
  );

  $root.on(
    'change',
    'input[type="checkbox"][name="practice"], input[type="checkbox"][name="quote"], input[type="checkbox"][name="location"]',
    function () {
      applyFilters(true);
    }
  );

  $pagination.on('click', 'button[data-page]', function () {
    var target = parseInt($(this).attr('data-page'), 10);
    if (!isFinite(target) || target === state.page || $(this).is(':disabled'))
      return;
    state.page = target;
    request();
  });

  applyFilters(true);
};

const videosAjax = () => {
  var $root = $('.video-filtarable');

  if (!$root.length || !window.ajax_object) return;

  var $search = $root.find('.video-filtarable__filter-search-field');
  var $posts = $root.find('.video-filtarable__posts');
  var $count = $root.find('.video-filtarable__posts-result span');
  var $pagination = $root.find('.video-filtarable__pagination');
  var state = { page: 1, totalPages: 1 };

  function getCheckedIDs(blockMod) {
    return $root
      .find('.fwp-dropdown--' + blockMod + ' input[type="checkbox"]:checked')
      .map(function () {
        var id = $(this).attr('data-term-id');
        return id ? id : $(this).val();
      })
      .get();
  }

  function debounce(fn, ms) {
    var t;
    return function () {
      clearTimeout(t);
      var args = arguments,
        ctx = this;
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, ms || 300);
    };
  }

  function renderPagination(total, page) {
    $pagination.empty();
    if (total <= 1) return;

    function btn(label, target, current, extraClass) {
      return jQuery('<button>', {
        type: 'button',
        text: label,
        class:
          'pagination__btn' +
          (current ? ' is-current' : '') +
          (extraClass ? ' ' + extraClass : ''),
        'data-page': target,
      });
    }

    if (page > 1) {
      $pagination.append(btn('Prev', page - 1, false, 'is-prev'));
    }

    var win = 5;
    var start = Math.max(1, page - 2);
    var end = Math.min(total, start + win - 1);
    start = Math.max(1, Math.min(start, end - win + 1));

    for (var i = start; i <= end; i++) {
      $pagination.append(btn(String(i), i, i === page));
    }

    if (page < total) {
      $pagination.append(btn('Next', page + 1, false, 'is-next'));
    }
  }

  function request() {
    var data = {
      action: 'fwp_videos',
      nonce: window.ajax_object.nonce,
      page: state.page,
      s: ($search.val() || '').trim(),
      practice: getCheckedIDs('practice'),
      quote: getCheckedIDs('quote'),
      locations: getCheckedIDs('location'),
    };

    $root.addClass('is-loading');
    $posts.attr('aria-busy', 'true');

    $.ajax({
      type: 'POST',
      url: window.ajax_object.ajax_url,
      data: data,
      dataType: 'json',
    })
      .done(function (resp) {
        if (!resp || !resp.success) {
          throw new Error('Invalid response');
        }
        var payload = resp.data || {};
        $posts.html(payload.html || '');
        $count.text(String(payload.total || 0));
        state.totalPages = payload.total_pages || 1;
        if (!payload.total) {
          $pagination.empty();
          return;
        }
        renderPagination(state.totalPages, state.page);
      })
      .fail(function (xhr) {
        console.error('AJAX failed', xhr?.responseText || xhr);
        $posts.html('<p>Something went wrong. Please try again.</p>');
        $count.text('0');
        $pagination.empty();
      })
      .always(function () {
        $root.removeClass('is-loading');
        $posts.removeAttr('aria-busy');
      });
  }

  function applyFilters(resetPage) {
    if (resetPage) state.page = 1;
    request();
  }

  $search.on(
    'input',
    debounce(function () {
      applyFilters(true);
    }, 300)
  );

  $root.on(
    'change',
    'input[type="checkbox"][name="practice"], input[type="checkbox"][name="quote"], input[type="checkbox"][name="location"]',
    function () {
      applyFilters(true);
    }
  );

  $pagination.on('click', 'button[data-page]', function () {
    var target = parseInt($(this).attr('data-page'), 10);
    if (!isFinite(target) || target === state.page || $(this).is(':disabled'))
      return;
    state.page = target;
    request();
  });

  applyFilters(true);
};

const videosGridAjax = () => {
  var $root = $('.video-grid-filtarable');

  if (!$root.length || !window.ajax_object) return;

  var $search = $root.find('.video-grid-filtarable__filter-search-field');
  var $posts = $root.find('.video-grid-filtarable__posts');
  var $count = $root.find('.video-grid-filtarable__posts-result span');
  var $pagination = $root.find('.video-grid-filtarable__pagination');
  var state = { page: 1, totalPages: 1 };

  function getCheckedIDs(blockMod) {
    return $root
      .find('.fwp-dropdown--' + blockMod + ' input[type="checkbox"]:checked')
      .map(function () {
        var id = $(this).attr('data-term-id');
        return id ? id : $(this).val();
      })
      .get();
  }

  function debounce(fn, ms) {
    var t;
    return function () {
      clearTimeout(t);
      var args = arguments,
        ctx = this;
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, ms || 300);
    };
  }

  function renderPagination(total, page) {
    $pagination.empty();
    if (total <= 1) return;

    function btn(label, target, current, extraClass) {
      return jQuery('<button>', {
        type: 'button',
        text: label,
        class:
          'pagination__btn' +
          (current ? ' is-current' : '') +
          (extraClass ? ' ' + extraClass : ''),
        'data-page': target,
      });
    }

    if (page > 1) {
      $pagination.append(btn('Prev', page - 1, false, 'is-prev'));
    }

    var win = 5;
    var start = Math.max(1, page - 2);
    var end = Math.min(total, start + win - 1);
    start = Math.max(1, Math.min(start, end - win + 1));

    for (var i = start; i <= end; i++) {
      $pagination.append(btn(String(i), i, i === page));
    }

    if (page < total) {
      $pagination.append(btn('Next', page + 1, false, 'is-next'));
    }
  }

  function request() {
    var data = {
      action: 'fwp_videos_grid',
      nonce: window.ajax_object.nonce,
      page: state.page,
      s: ($search.val() || '').trim(),
      practice: getCheckedIDs('practice'),
      quote: getCheckedIDs('quote'),
      locations: getCheckedIDs('location'),
    };

    $root.addClass('is-loading');
    $posts.attr('aria-busy', 'true');

    $.ajax({
      type: 'POST',
      url: window.ajax_object.ajax_url,
      data: data,
      dataType: 'json',
    })
      .done(function (resp) {
        if (!resp || !resp.success) {
          throw new Error('Invalid response');
        }
        var payload = resp.data || {};
        $posts.html(payload.html || '');
        $count.text(String(payload.total || 0));
        state.totalPages = payload.total_pages || 1;
        if (!payload.total) {
          $pagination.empty();
          return;
        }
        renderPagination(state.totalPages, state.page);
      })
      .fail(function (xhr) {
        console.error('AJAX failed', xhr?.responseText || xhr);
        $posts.html('<p>Something went wrong. Please try again.</p>');
        $count.text('0');
        $pagination.empty();
      })
      .always(function () {
        $root.removeClass('is-loading');
        $posts.removeAttr('aria-busy');
      });
  }

  function applyFilters(resetPage) {
    if (resetPage) state.page = 1;
    request();
  }

  $search.on(
    'input',
    debounce(function () {
      applyFilters(true);
    }, 300)
  );

  $root.on(
    'change',
    'input[type="checkbox"][name="practice"], input[type="checkbox"][name="quote"], input[type="checkbox"][name="location"]',
    function () {
      applyFilters(true);
    }
  );

  $pagination.on('click', 'button[data-page]', function () {
    var target = parseInt($(this).attr('data-page'), 10);
    if (!isFinite(target) || target === state.page || $(this).is(':disabled'))
      return;
    state.page = target;
    request();
  });

  applyFilters(true);
};

/**
 * Custom Attornys Slider
 */
const attorneysSlider = () => {
  const prevBtn = document.querySelector('.attorneys-arrow-prev');
  const nextBtn = document.querySelector('.attorneys-arrow-next');
  const items = document.querySelectorAll('.video-slider__item');

  if (!items.length || !prevBtn || !nextBtn) {
    return;
  }

  let currentIndex = [...items].findIndex((item) =>
    item.classList.contains('active')
  );
  if (currentIndex === -1) currentIndex = 0;
  items[currentIndex].classList.add('active');

  function updateButtons() {
    if (currentIndex === 0) {
      prevBtn.classList.add('slick-disabled');
    } else {
      prevBtn.classList.remove('slick-disabled');
    }

    if (currentIndex === items.length - 1) {
      nextBtn.classList.add('slick-disabled');
    } else {
      nextBtn.classList.remove('slick-disabled');
    }
  }

  function updateActive(newIndex) {
    items[currentIndex].classList.remove('active');
    currentIndex = newIndex;
    items[currentIndex].classList.add('active');
    updateButtons();
  }

  updateButtons();

  nextBtn.addEventListener('click', function () {
    if (currentIndex < items.length - 1) {
      updateActive(currentIndex + 1);
    }
  });

  prevBtn.addEventListener('click', function () {
    if (currentIndex > 0) {
      updateActive(currentIndex - 1);
    }
  });
};

/**
 * Glossaty Live filter and Rebuild HTML items
 */
const glossaryFiltration = () => {
  const searchInput = document.getElementById('glossary-search');
  const container = document.querySelector('.glossary-container');
  if (!container) return;

  function liveSearch() {
    const filter = searchInput.value.toLowerCase();
    const items = container.querySelectorAll('.glossaryLink');

    items.forEach((item) => {
      const text = item.textContent.toLowerCase();
      item.closest('li, div').style.display =
        !filter || text.includes(filter) ? '' : 'none';
    });
  }

  searchInput.addEventListener('input', debounce(liveSearch, 300));

  function filterByLetter(letter) {
    const items = container.querySelectorAll('.glossaryLink');

    items.forEach((item) => {
      const text = item.textContent.toLowerCase();
      item.closest('li, div').style.display = text.startsWith(
        letter.toLowerCase()
      )
        ? ''
        : 'none';
    });
  }

  const observer = new MutationObserver(function (mutations, obs) {
    const glossaryList = container.querySelector('.glossaryList');
    const activeLetterLink = container.querySelector(
      '.ln-letters a.ln-selected'
    );

    if (glossaryList && activeLetterLink) {
      let letterDiv = container.querySelector('.glossary-current-letter');
      if (!letterDiv) {
        letterDiv = document.createElement('div');
        letterDiv.className = 'glossary-current-letter';
        glossaryList.parentNode.insertBefore(letterDiv, glossaryList);
      }
      letterDiv.textContent = activeLetterLink.textContent.trim();

      container.querySelectorAll('.glossaryLink').forEach(function (link) {
        const tooltipHtml = link.getAttribute('data-cmtooltip');
        if (tooltipHtml) {
          const parser = new DOMParser();
          const decodedHtml = parser.parseFromString(tooltipHtml, 'text/html');

          const body = decodedHtml.querySelector('.glossaryItemBody');
          if (
            body &&
            !link.nextElementSibling?.classList.contains('glossary-content')
          ) {
            const div = document.createElement('div');
            div.className = 'glossary-content';
            div.textContent = body.textContent.trim();
            link.insertAdjacentElement('afterend', div);
          }

          link.removeAttribute('data-cmtooltip');
        }
      });

      const lettersNav = container.querySelectorAll('.ln-letters a');
      lettersNav.forEach((a) => {
        a.addEventListener('click', function () {
          setTimeout(() => {
            const newActive = container.querySelector(
              '.ln-letters a.ln-selected'
            );
            if (letterDiv) {
              letterDiv.textContent = newActive?.textContent.trim() || '';
            }

            searchInput.value = '';

            const letter = newActive?.textContent || '';
            filterByLetter(letter);
          }, 50);
        });
      });

      obs.disconnect();
    }
  });

  observer.observe(container, { childList: true, subtree: true });
};

/**
 * Scripts which runs after DOM load
 */
$(document).on('ready', function () {
  // ACF Google Map JS code

  /*
   *  This function will render a Google Map onto the selected jQuery element
   */
  function render_map($el) {
    // var
    var $markers = $el.find('.marker');
    var styles = [
      {
        featureType: 'administrative.land_parcel',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'administrative.neighborhood',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'poi',
        elementType: 'labels.text',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'poi.business',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'road',
        elementType: 'labels',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'road',
        elementType: 'labels.icon',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'road.arterial',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry.fill',
        stylers: [
          {
            color: '#ffeb3b',
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'labels',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'road.local',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'road.local',
        elementType: 'geometry',
        stylers: [
          {
            color: '#ffeb3b',
          },
        ],
      },
      {
        featureType: 'transit',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
      {
        featureType: 'water',
        elementType: 'labels.text',
        stylers: [
          {
            visibility: 'off',
          },
        ],
      },
    ];

    // vars
    var args = {
      zoom: 16,
      // eslint-disable-next-line import/no-unresolved,no-undef
      center: new google.maps.LatLng(0, 0),
      // eslint-disable-next-line no-undef
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      scrollwheel: true,
      styles: styles, // Uncomment for map styling
      disableDefaultUI: true,
    };

    // create map
    // eslint-disable-next-line no-undef
    var map = new google.maps.Map($el[0], args);

    // add a markers reference
    map.markers = [];

    // add markers
    $markers.each(function () {
      add_marker($(this), map);
    });

    // center map
    center_map(map);
  }

  /*
   *  This function will add a marker to the selected Google Map
   */
  var infowindow;

  function add_marker($marker, map) {
    // var
    // eslint-disable-next-line no-undef
    var latlng = new google.maps.LatLng(
      $marker.attr('data-lat'),
      $marker.attr('data-lng')
    );

    // create marker
    // eslint-disable-next-line no-undef
    var marker = new google.maps.Marker({
      position: latlng,
      map: map,
      icon: $marker.data('marker-icon'), //uncomment if you use custom marker
    });

    // add to array
    map.markers.push(marker);

    // if marker contains HTML, add it to an infoWindow
    if ($.trim($marker.html())) {
      // create info window
      // eslint-disable-next-line no-undef
      infowindow = new google.maps.InfoWindow();

      // show info window when marker is clicked
      // eslint-disable-next-line no-undef
      google.maps.event.addListener(marker, 'click', function () {
        // Close previously opened infowindow, fill with new content and open it
        infowindow.close();
        infowindow.setContent($marker.html());
        infowindow.open(map, marker);
      });
    }
  }

  /*
   *  This function will center the map, showing all markers attached to this map
   */
  function center_map(map) {
    // vars
    // eslint-disable-next-line no-undef
    var bounds = new google.maps.LatLngBounds();

    // loop through all markers and create bounds
    $.each(map.markers, function (i, marker) {
      // eslint-disable-next-line no-undef
      var latlng = new google.maps.LatLng(
        marker.position.lat(),
        marker.position.lng()
      );
      bounds.extend(latlng);
    });

    // only 1 marker?
    if (map.markers.length == 1) {
      // set center of map
      map.setCenter(bounds.getCenter());
    } else {
      // fit to bounds
      map.fitBounds(bounds);
    }
  }

  /*
   *  This function will render each map when the document is ready (page has loaded)
   */
  $('.acf-map').each(function () {
    render_map($(this));
  });
  /**
   * Glossary Filter
   */
  glossaryFiltration();

  /**
   * Make elements equal height
   */
  // $('.matchHeight').matchHeight();

  /**
   * IE Object-fit cover polyfill
   */
  // if ($('.of-cover').length) {
  //   objectFitImages('.of-cover');
  // }

  /**
   * Add fancybox to images
   */
  // $('.gallery-item')
  //   .find('a[href$="jpg"], a[href$="png"], a[href$="gif"]')
  //   .attr('rel', 'gallery')
  //   .attr('data-fancybox', 'gallery');
  // $(
  //   '.fancybox, a[rel*="album"], a[href$="jpg"], a[href$="png"], a[href$="gif"]'
  // ).fancybox({
  //   minHeight: 0,
  //   helpers: {
  //     overlay: {
  //       locked: false,
  //     },
  //   },
  // });

  /**
   * Init parallax
   */
  // jarallaxElement();
  // jarallax(document.querySelectorAll('.jarallax'), {
  //   speed: 0.5,
  // });

  /**
   * Detect element appearance in viewport
   */

  // ScrollOut({
  //   threshold: 0.5,
  //   once: true,
  //   onShown: function (element) {
  //     if ($(element).is('.ease-order')) {
  //       $(element)
  //         .find('.ease-order__item')
  //         .each(function (i) {
  //           let $this = $(this);
  //           $(this).attr('data-scroll', '');
  //           window.setTimeout(function () {
  //             $this.attr('data-scroll', 'in');
  //           }, 300 * i);
  //         });
  //     }
  //   },
  // });

  $('.js-locations-slider').on('wheel', function (e) {
    if (this.scrollWidth > this.clientWidth) {
      e.preventDefault();

      let scrollAmount = e.originalEvent.deltaY;
      let $el = $(this);

      $el.stop().animate(
        {
          scrollLeft: $el.scrollLeft() + scrollAmount,
        },
        300,
        'swing'
      );
    }
  });
  /**
   * Remove placeholder on click
   */
  const removeFieldPlaceholder = () => {
    $('input, textarea').each((i, el) => {
      $(el)
        .data('holder', $(el).attr('placeholder'))
        .on('focusin', () => {
          $(el).attr('placeholder', '');
        })
        .on('focusout', () => {
          $(el).attr('placeholder', $(el).data('holder'));
        });
    });
  };

  removeFieldPlaceholder();

  $(document).on('gform_post_render', () => {
    removeFieldPlaceholder();
  });

  /**
   * Scroll to Gravity Form confirmation message after form submit
   */
  $(document).on('gform_confirmation_loaded', function (event, formId) {
    let $target = $('#gform_confirmation_wrapper_' + formId);
    if ($target.length) {
      $('html, body').animate({ scrollTop: $target.offset().top - 50 }, 500);
      return false;
    }
  });

  /**
   * Hide gravity forms required field message on data input
   */
  $('body').on(
    'change keyup',
    '.gfield input, .gfield textarea, .gfield select',
    function () {
      let $field = $(this).closest('.gfield');
      if ($field.hasClass('gfield_error') && $(this).val().length) {
        $field.find('.validation_message').hide();
      } else if ($field.hasClass('gfield_error') && !$(this).val().length) {
        $field.find('.validation_message').show();
      }
    }
  );

  /**
   * Add `is-active` class to menu-icon button on Responsive menu toggle
   * And remove it on breakpoint change
   */
  $(window)
    .on('toggled.zf.responsiveToggle', function () {
      $('.menu-icon').toggleClass('is-active');
    })
    .on('changed.zf.mediaquery', function () {
      $('.menu-icon').removeClass('is-active');
    });

  /**
   * Close responsive menu on orientation change
   */
  $(window).on('orientationchange', function () {
    setTimeout(function () {
      if ($('.menu-icon').hasClass('is-active') && window.innerWidth < 641) {
        $('[data-responsive-toggle="main-menu"]').foundation('toggleMenu');
      }
    }, 200);
  });
});

function initCaseSlider(
  containerSelector,
  arrowNextSelector,
  arrowPrevSelector
) {
  let stepMain = 143;
  let stepNotActive = 103;

  let $container = $(containerSelector);
  let $cases = $container.find('.case-studies__case');
  let $arrowNext = $(arrowNextSelector);
  let $arrowPrev = $(arrowPrevSelector);

  $cases.each(function () {
    $(this).data('mainShift', 0);
    $(this).data('extraShift', 0);
  });

  function updateTransforms() {
    $cases.each(function () {
      let mainShift = $(this).data('mainShift') * stepMain;
      let extraShift = $(this).data('extraShift') * stepNotActive;
      let totalShift = mainShift + extraShift;
      $(this).css('transform', 'translateX(-' + totalShift + 'px)');
    });
  }

  function checkArrows() {
    let activeCount = $cases.not('.not-active').length;
    let deactivated = $cases.filter('.not-active');
    let deactivatedCount = deactivated.length;

    if (activeCount <= 1) $arrowNext.addClass('slick-disabled');
    else $arrowNext.removeClass('slick-disabled');

    if (deactivatedCount === 0) $arrowPrev.addClass('slick-disabled');
    else $arrowPrev.removeClass('slick-disabled');

    $cases.css('opacity', '');
    if (deactivatedCount > 0) deactivated.last().css('opacity', '0.1');
  }

  function moveNext() {
    let $nextToDeactivate = $cases.not('.not-active').first();
    if (!$nextToDeactivate.length) return;

    $nextToDeactivate.addClass('not-active').data('extraShift', 1);

    $cases.not('.not-active').each(function () {
      let shift = $(this).data('mainShift') || 0;
      $(this).data('mainShift', shift + 1);
    });

    updateTransforms();
    checkArrows();
  }

  function movePrev() {
    let $lastDeactivated = $cases.filter('.not-active').last();
    if (!$lastDeactivated.length) return;

    $lastDeactivated.removeClass('not-active').data('extraShift', 0);

    $cases
      .not('.not-active')
      .not($lastDeactivated)
      .each(function () {
        let shift = $(this).data('mainShift') || 0;
        $(this).data('mainShift', shift - 1);
      });

    updateTransforms();
    checkArrows();
  }

  $arrowNext.on('click', moveNext);
  $arrowPrev.on('click', movePrev);

  let touchStartX = 0;
  let minSwipeDistance = 50;

  $container.on('touchstart', function (e) {
    touchStartX = e.originalEvent.touches[0].clientX;
  });

  $container.on('touchend', function (e) {
    let touchEndX = e.originalEvent.changedTouches[0].clientX;
    let distance = touchEndX - touchStartX;

    if (Math.abs(distance) > minSwipeDistance) {
      if (distance < 0) moveNext();
      else movePrev();
    }
  });

  // let isDragging = false;
  // let dragStartX = 0;
  //
  // $container.on('mousedown', function (e) {
  //   isDragging = true;
  //   dragStartX = e.clientX;
  //   e.preventDefault();
  // });
  //
  // $(document).on('mousemove', function (e) {
  //   if (!isDragging) return;
  //   e.preventDefault();
  // });
  //
  // $(document).on('mouseup', function (e) {
  //   if (!isDragging) return;
  //   isDragging = false;
  //
  //   let dragEndX = e.clientX;
  //   let distance = dragEndX - dragStartX;
  //
  //   if (Math.abs(distance) > minSwipeDistance) {
  //     if (distance < 0) moveNext();
  //     else movePrev();
  //   }
  // });

  checkArrows();
}

/**
 * Scripts which runs after all elements load
 */
$(window).on('load', function () {
  if (typeof AOS !== 'undefined') {
    AOS.init({
      offset: 100,
      duration: 800,
      once: true,
    });
  }

  let $preloader = $('.preloader');
  if ($preloader.length) {
    $preloader.addClass('preloader--hidden');
  }

  setTimeout(() => {
    initCaseSlider(
      '.case-studies__cases',
      '.case-arrow-next',
      '.case-arrow-prev'
    );
  }, 50);

  setHeaderHeightVar();
  calendarSliderControls();
  ourProcessSwitcher();
  faqSearch();
  accordionAnimation();
  fwpDropdown();

  // AJAX
  careResultsAjax();
  videosAjax();
  videosGridAjax();

  attorneysSlider();
});

/**
 * Scripts which runs at window resize
 */
$(window).on('resize', function () {
  setHeaderHeightVar();
  ourProcessSwitcher();
});

/**
 * Scripts which runs on scrolling
 */
$(window).on('scroll', function () {
  // jQuery code goes here
});

document.addEventListener('click', function (e) {
  if (e.target.classList.contains('read-more-content')) {
    const mainBlock = e.target.closest('.main-content');
    const fullContentHTML = mainBlock.querySelector('.full-content').innerHTML;

    const popup = document.getElementById('text-popup');
    popup.querySelector('.popup-content').innerHTML = fullContentHTML;
    popup.style.display = 'flex';
  }

  if (
    e.target.classList.contains('popup-close') ||
    e.target.id === 'text-popup'
  ) {
    document.getElementById('text-popup').style.display = 'none';
  }
});

/**
 * Home hero banner moving
 */
// document.addEventListener('DOMContentLoaded', function () {
//   const banner = document.querySelector('.hero-banner');
//   const handle = document.querySelector('.hero-banner');
//   const header = document.querySelector('header');
//   const body = document.querySelector('body');
//
//   if (!banner || !handle || !header) {
//     return;
//   }
//
//   let isDragging = false;
//   let startX = 0;
//   let startY = 0;
//   let translateX = getMaxTranslateX();
//   let isOpen = false;
//   let isHorizontalDrag = false;
//
//   function getMaxTranslateX() {
//     return window.innerWidth <= 1023
//       ? banner.offsetWidth - 15
//       : banner.offsetWidth - 58;
//   }
//
//   function setTranslateX(x) {
//     banner.style.transform = `translateX(${x}px)`;
//     updateOpacity(x);
//   }
//
//   function updateOpacity(x) {
//     const max = getMaxTranslateX();
//     const ratio = x / max;
//     header.style.opacity = Math.max(0, Math.min(1, ratio));
//   }
//
//   function updateBodyOverflow(isDraggingHorizontally, x) {
//     if (window.innerWidth <= 768) {
//       // Only apply overflow: hidden when dragging horizontally (left/right)
//       if (isDraggingHorizontally && x < window.innerWidth - 30) {
//         body.style.overflow = 'hidden';
//       } else {
//         body.style.overflow = 'unset';
//       }
//     } else {
//       body.style.overflow = 'unset';
//     }
//   }
//
//   function onDragStart(e) {
//     isDragging = true;
//     startX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
//     startY = e.type.includes('touch') ? e.touches[0].clientY : e.clientY;
//     isHorizontalDrag = false;
//   }
//
//   function onDragMove(e) {
//     if (!isDragging) return;
//
//     const clientX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
//     const clientY = e.type.includes('touch') ? e.touches[0].clientY : e.clientY;
//     const dx = clientX - startX;
//     const dy = clientY - startY;
//     const max = getMaxTranslateX();
//     const threshold = max * 0.08;
//
//     // Determine if this is primarily a horizontal drag (left/right)
//     if (!isHorizontalDrag && Math.abs(dx) > Math.abs(dy) * 2) {
//       isHorizontalDrag = true;
//     }
//
//     // Calculate new position based on drag
//     let newX = isOpen ? max + dx : dx;
//
//     // Apply limits based on current state
//     if (isOpen) {
//       // When open, only allow dragging to the right (closing)
//       newX = Math.max(0, Math.min(max, newX));
//     } else {
//       // When closed, only allow dragging to the left (opening)
//       newX = Math.max(0, Math.min(max, newX));
//     }
//
//     setTranslateX(newX);
//     updateBodyOverflow(isHorizontalDrag, newX);
//
//     // If drag exceeds threshold, complete the action immediately
//     if (isOpen && newX < max - threshold) {
//       // Close the banner if dragged more than 9% when open
//       completeDrag(0, false);
//     } else if (!isOpen && newX > threshold) {
//       // Open the banner if dragged more than 9% when closed
//       completeDrag(max, true);
//     }
//   }
//
//   function onDragEnd() {
//     if (!isDragging) return;
//
//     const currentX = parseFloat(
//       banner.style.transform.match(/translateX\((.*?)px\)/)[1]
//     );
//     const max = getMaxTranslateX();
//     const threshold = max * 0.05;
//
//     // Determine final position based on current drag position
//     if (isOpen) {
//       // If banner is open and dragged less than threshold, return to open
//       if (currentX >= max - threshold) {
//         completeDrag(max, true);
//       } else {
//         completeDrag(0, false);
//       }
//     } else {
//       // If banner is closed and dragged less than threshold, return to closed
//       if (currentX <= threshold) {
//         completeDrag(0, false);
//       } else {
//         completeDrag(max, true);
//       }
//     }
//   }
//
//   function completeDrag(finalX, openState) {
//     isDragging = false;
//     translateX = finalX;
//     isOpen = openState;
//     isHorizontalDrag = false;
//
//     setTranslateX(translateX);
//     updateBodyOverflow(false, translateX); // Reset overflow when drag completes
//   }
//
//   handle.addEventListener('mousedown', onDragStart);
//   handle.addEventListener('touchstart', onDragStart);
//   window.addEventListener('mousemove', onDragMove);
//   window.addEventListener('touchmove', onDragMove);
//   window.addEventListener('mouseup', onDragEnd);
//   window.addEventListener('touchend', onDragEnd);
// });

/**
 * Statistic animation
 */
document.addEventListener('DOMContentLoaded', () => {
  const statistics = document.querySelectorAll('.js-statistic');

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
          obs.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 1,
    }
  );

  statistics.forEach((stat) => observer.observe(stat));
});
